import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import CleaningProducts from '../components/CleaningProducts';
import Gallery from '../components/Gallery';
import AdditionalServices from '../components/AdditionalServices';
import FAQ from '../components/FAQ';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import { getSettings } from '../api';

const Home = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await getSettings();
      setSettings(response.data);
    } catch (error) {
      console.error('Failed to load settings:', error);
    }
  };

  const seoData = settings?.seo?.home || {
    title: 'Клининговая компания Bell',
    description: 'Профессиональная уборка квартир в Минске',
    keywords: 'уборка, клининг, минск'
  };

  return (
    <>
      <Helmet>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
      </Helmet>
      <div className="min-h-screen">
        <Header />
        <Hero />
        <Services />
        <About />
        <CleaningProducts />
        <Gallery />
        <AdditionalServices />
        <FAQ />
        <ContactForm />
        <Footer />
      </div>
    </>
  );
};

export default Home;